<template>
<div>
    <Modal
        :value="showAdModel"
        :title="addBox.title"
        :footer-hide="true"
        @on-cancel="cancel"
        :mask-closable="false"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
        <FormItem label="标题：" prop="title">
            <Input type="text" v-model="formData.title"></Input>
        </FormItem>
        <FormItem label="链接" prop="url">
                <Input v-model="formData.url"  class="formInput" placeholder="域名需为https或http格式链接" value=""></Input>
                </Input>
        </FormItem>

        <FormItem label="内容：" v-if="pos_type === 2" prop="content">
            <Input type="textarea" :rows="4" v-model="formData.content"></Input>
        </FormItem>
        <FormItem label="缩略图：" v-if="pos_type === 1" prop="content">
            <ImgUpload ref="upImg" :action="upload.actionUrl" :num="1" @setThumbUrl="setThumbUrl"></ImgUpload>
        </FormItem>
        <FormItem label="排序：" prop="sort_num">
            <Input type="text" v-model="formData.sort_num"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
            <RadioGroup v-model="formData.status">
                <Radio label="1">
                    <span>显示</span>
                </Radio>
                <Radio label="2">
                    <span>隐藏</span>
                </Radio>
            </RadioGroup>

        </FormItem>
        <FormItem label="有效期：" prop="startEnd">
            <DatePicker type="daterange" @on-change="setTimeStartEnd" :clearable = "false" format="yyyy-MM-dd" :value="formData.startEnd" placement="bottom-end" placeholder="选择有效期" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem>
            <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
        </FormItem>
    </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param pos_id Number 上级ID
 * @param pos_type Number 广告位类型
 * @param showAdModel boolean 对话框开关 true false
 * @param fn function 回调函数
 */
import ImgUpload from "../common/upload"
import common from '@/common/common';
import SearchSelect from '../common/searchSelect'; //搜索商家
import moment from 'moment';
import vm from "../../event.js";
var urlType = "1"
    export default {
        props:{
            pos_id:Number,
            pos_type:Number,
            showAdModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        components: {
            ImgUpload,
            SearchSelect,
        },
        name: "Model2",
        data () {
            return {
                disabled:false,//禁用确定按钮
                addBox:{//弹框组
                    title:'添加/编辑属性',//弹框标题
                },
                upload:{//图片上传组
                    actionUrl:this.config.urlArray.commonUploadImage,//上传图片接口
                },
                menuArray:{  //功能外链
                    funcId:0, //功能外链的id
                    goodsId:0, // 商品模糊搜索id
                    ArtsId:0, // 商品模糊搜索id
                    form_id:0,  //表单模糊搜索id
                    funcData:[],
                },
                url1:"",
                status:true,
                formData: {//表单数据
                    title:'',
                    url:"", //链接
                    url_type:'1', // 功能菜单id
                    content:'',
                    position_id:0,
                    startEnd:[moment().format('YYYY-MM-DD'), moment().add(30,'days').format('YYYY-MM-DD')],
                    start_time:moment().format('YYYY-MM-DD'),
                    end_time:moment().add(30,'days').format('YYYY-MM-DD'),
                    sort_num:'100',
                    status:'1',
                    is_forever:'1',  //	是否永久 1=永久
                },
                ruleCustom: {//验证
                    title: [
                        { required: true, message: '标题必须填写', trigger: 'blur' },
                        { min: 1, max: 100, message: '标题长度1 - 100', trigger: 'blur' }
                    ],
                    url: [
                    ],
                    content: [
                        { required: true, message: '广告内容必须填写', trigger: 'blur' }
                    ],
                    startEnd: [
                        { validator: this.validDate, trigger: 'blur' }
                    ],
                    sort_num: [
                        { required: true, message: '排序必须填写', trigger: 'blur' },
                        { min: 1, max: 10, message: '排序长度1 - 10', trigger: 'blur' }
                    ]
                }
            }
        },
        watch:{
            urlType(val){
                urlType = val
            }
        },
        created (){
        },
        methods: {
            openOrClose(value){
                if(value === true){
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.id = this.editFormData.id
                        this.formData.title = this.editFormData.title
                        this.formData.url_type = this.editFormData.url_type.toString()
                        this.formData.content = this.editFormData.content
                        this.$nextTick(() => {
                           if(this.pos_type == 1){
                                let hasUpload = [{
                                    status:'finished',
                                    response:{data: this.editFormData.content}
                                }]
                                this.$refs.upImg.setHasUpload(hasUpload)//为上传组件付默认值
                            }
                        })

                        this.url1 = this.editFormData.url
                        this.formData.url = this.editFormData.url
                        this.formData.position_id = this.editFormData.position_id
                        this.formData.startEnd = [this.editFormData.start_time,this.editFormData.end_time]
                        this.formData.start_time = this.editFormData.start_time
                        this.formData.end_time = this.editFormData.end_time
                        this.formData.sort_num = String(this.editFormData.sort_num)
                        this.formData.status = String(this.editFormData.status)
                    }else{
                        this.formData.position_id = this.pos_id
                    }

                }else{//关闭弹框后要做的处理
                    this.$emit('update:pos_id',0)//更新上级IP为原始状态
                    this.resetForm()
                }
            },
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if(!this.status){
                            return false
                        }

                        this.axios.post(this.config.urlArray.ggStore,this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.$emit('update:pos_id',0)//更新上级Id为原始状态
                                this.resetForm()
                                this.fn()
                                vm.$emit("two-to-one", '0'); // 添加广告确定后传递给addModel组件
                            },()=>{this.disabled = false;})

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                    }
                })
            },
            cancel () {//对话框关闭
                this.$emit('update:showAdModel',false);
                this.$emit('update:pos_type',0);
                this.resetForm();
            },
            resetForm () {//重置表单
                if(this.pos_type == 1){
                    this.$refs.upImg.clearImg()//清除已上传的图片
                }
                this.disabled = false;//恢复提交按钮为激活状态
                // 清空值
                this.url1 = '';
                this.formData = {//表单数据
                    title:'',
                    url:"", //链接
                    url_type:'0', // 功能菜单id
                    content:'',
                    position_id:0,
                    startEnd:[moment().format('YYYY-MM-DD'), moment().add(30,'days').format('YYYY-MM-DD')],
                    start_time:moment().format('YYYY-MM-DD'),
                    end_time:moment().add(30,'days').format('YYYY-MM-DD'),
                    sort_num:'100',
                    status:'1',
                }

                this.$refs.formData.resetFields();//重置表单
            },
            setThumbUrl(url){//获取图片上传后的路径
                this.formData.content = url;
            },
            setTimeStartEnd(value){//设置开始和结束时间
                this.formData.startEnd = [value[0],value[1]]
                this.formData.start_time = value[0]
                this.formData.end_time = value[1]
            },
            validDate(rule, value, callback){//验证有效期
                if(value[0] == '' || value[1] == ''){
                    callback(new Error('有效期格式错误'))
                }
                callback()
            },
        }
    }
</script>
<style lang="scss" scoped>
    .formInput{
       display: flex;
    }
    .formInput .items{
        margin-right: 10px;
        width: 50% !important;
    }
</style>
